/** Open a same-origin learner URL in a new tab. Does not set noopener so lab completion can still notify the course tab. */
export function openLearnerTab(path: string) {
  if (!path) return;
  const href = path.startsWith('/') ? path : `/${path}`;
  window.open(href, '_blank');
}
